var Offer = /** @class */ (function () {
    function Offer() {
    }
    return Offer;
}());
export { Offer };
